// extracted by mini-css-extract-plugin
module.exports = {"Section":"Section_Section__IBny_","Container":"Section_Container__3ZPLz","Title":"Section_Title__1PFsu","Loading":"Section_Loading__38kDt"};